export enum Flipper {
  ShoppingList = 'pickup_shopping_list',
}
